import CoreMenuInfoPage from 'src/dispensary/core-menu/info';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

export default CoreMenuInfoPage;
